/*
 * Mile Four Chicken Name Generator
 * Shopify theme asset
 * File name: mf4-chicken-name-generator-fixed.js
 */
(function () {
  'use strict';

  function initializeGenerator() {
  var scope = document.getElementById('mf4-top');
  if (!scope) return false;
  if (scope.dataset.generatorReady === 'true') return true;

  function $(selector) {
    return scope.querySelector(selector);
  }

  function $all(selector) {
    return scope.querySelectorAll(selector);
  }

  var elements = {
    vibe: $('#mf4-vibe'),
    pills: $('#mf4-quick-vibes'),
    letter: $('#mf4-letter'),
    generate: $('#mf4-generate'),
    refresh: $('#mf4-refresh'),
    moreNames: $('#mf4-more-names'),
    results: $('#mf4-results'),
    empty: $('#mf4-empty'),
    favorites: $('#mf4-favorites')
  };

  if (
    !elements.vibe ||
    !elements.pills ||
    !elements.letter ||
    !elements.generate ||
    !elements.refresh ||
    !elements.results ||
    !elements.empty ||
    !elements.favorites
  ) {
    console.warn('[Mile Four Name Generator] Required module elements were not found.');
    return false;
  }

  var vibeValues = {
    'any': 'any',
    'punny': 'punny',
    'funny': 'funny',
    'pop culture': 'pop_culture',
    'cute': 'cute',
    'color': 'color',
    'food & drinks': 'food_drinks',
    'earth/nature': 'earth_nature',
    'old lady': 'old_lady',
    'pairs': 'pairs',
    'trios': 'trios',
    'rooster': 'rooster'
  };

  var hasActivePill = false;
  $all('#mf4-quick-vibes .pill').forEach(function (button) {
    var label = button.textContent.trim().toLowerCase();
    var value = vibeValues[label];

    if (value) {
      button.setAttribute('data-val', value);
    }

    if (button.getAttribute('aria-pressed') === 'true') {
      hasActivePill = true;
    }
  });

  if (!hasActivePill) {
    var anyButton = elements.pills.querySelector('.pill[data-val="any"]');
    if (anyButton) {
      anyButton.setAttribute('aria-pressed', 'true');
    }
  }

  scope.dataset.generatorReady = 'true';

  var NAMES = {
    punny: ["Abrahen Lincoln","Albert Eggstein","Amelia Egghart","Angelina Jopeep","Annie Yolkley","Attila the Hen","Audrey Henburn","Bird Lancaster","Birdzilla","Chew-bock-a","Chick Jagger","Chick-a-las Cage","Chick-eel O'neil","Chick-ira","Chickovsky","Cluck Kent","Cluck Norris","Clucky Cheese","Darth Egger","David Beekham","Edward Scissor Beak","Eggatha Christie","Eggdar Allan Poe","Feather Locklear","Goldie Hen","Gwyneth Poultry","Hen Solo","Henifer Aniston","Henneth Paltrow","Henrique Egglecias","Hillary Fluff","Liam Hensworth","Lindsay Lohen","Little Red Riding Hen","Mary Poopins","Meryl Cheep","Obi Wan Henobi","Oprah Henfrey","Princess Lay-a","Roo-Paul","Sophia Lorhen","Yolkahontas","Yolko Ono"],
    funny: ["Alarm Clock","Amarillo","Babz","Big Bertha","Boc-boc","Bossy Boots","Bug Eater","Chick-fil-a","Crispy","Cute But Psycho","Ditsy","Dodo","Fiesta","Flappy Bird","Flash","Homerun","Jeepers Cheepers","Lil’ Layin","Loco","Loofah","Midget","Mop Head","Mother Clucker","Nosey Nellie","Pipsqueak","Poop Maker","Pox","Psycho Suzie","Public Nuisance","Ruff Cluck","Sal Monella","Soft Boiled","Tango Mango","The Dodger","The Fluffer Butters","Toe Jam","Trouble","Two Left Feet","Tyrannosaurus Pecks","Wormy"],
    pop_culture: ["Alice","Anastasia","Ariel","Arya","Aurora","Bashful","Belle","Betty White","Cher","Chicken Little","Cinderella","Cindy-Lou","Clara Cluck","Cruella (DeVil)","Dixie Chick","Doc","Dopey","Dutchess","Elsa","Goldilocks","Grumpy","Happy","Henrietta","Hermione","Katniss","Lady Gaga","Lafonda","Lucille Ball","Maleficent","Merida","Minnie","Miss Almira","Miss Marple","Miss Pepperpot","Mrs. Burns","Mrs. Frizzle","Mrs. O'Leary","Nala","Pigwidgeon","Pocahontas","Professor McGonagall","Rapunzel","Road runner","Sansa","Sleepy","Sneezy","Snow White","Thumbelina","Thumper","Tiana","Tinker Bell","Ursula","Wendy Darling"],
    cute: ["Angel","Baby","Beauty","Bizzie/Busy","Bossy","Bow","Bubbles","Chick","Chickie","Chirpy","Cluck","Clucky","Coco","Comet","Cosmo","Crackle","Cupid","Diva","Doodle","Dot/Dottie","Dumpling","Fleur","Fluffy Butt","Freckles","Frizzle","Glitter","Henny","Henny Penny","Jazz(y)","Jewel","Lady Bird","Little Bit","Little Red","Lovey","Miss Pompom","Miss Sparkles","Mrs. Pecks","Noelle","Nugget","Pecky","Peep","Peepers","Pip","Pixie","Pompom","Poppy","Princess Countess","Princess Fluffy Butt","Princess Layer","Puff","Pumpkin","Rainbow Dash","Rebel","Snowball","Socks","Sparkles","Speckles","Splash","Spot","Spotty","Squashie","Squeak","Star","Sweetie","Tootsie","Trixie","Tweety","Twizzle","Waddles"],
    color: ["Bellatrix","Blackie","Crow","Ebony","Espresso","Mocha","Morticia (Addams)","Mystic","Obsidian","Onyx","Phantom","Puddle","Shade","Shadow","Smokey","Blondie","Brownie","Buffy","Butter","Buttercup","Butterscotch","Caramel","Chocolate","Cinnamon","Cocoa","Copper","Fudge","Goldie","Honey","Penny","Alaska","Alpine","Angel","Arctic","Blanco","Blizzard","Charmin","Coconut","Cool Whip","Cotton","Ghost","Ivory","Powder","Snowball","Sugar","Blue","Bluebelle","Hazel","Indigo","Lemon","Maroon","Olive","Periwinkle","Red","Scarlet","Sepia","Sienna","Taupe","Velvet","Violet"],
    food_drinks: ["Benedict","Burrito","Chili","Eggs Benedict","Frittata","Nacho","Omelette","Pizza","Quiche","Reuben","Schnitzel","Scramble","Spaghetti","Taco","Apple","Apricot","Blackberry","Blueberry","Bok Bok Choy","Cherry","Clementine","Kiwi","Peaches","Mango","Peach","Pumpkin","Raspberry","Strawberry","Bon Bon","Cheese Puff","Cookie","Cotton Candy","Cream Puff","Cupcake","Custard","Marshmallow","Popcorn","Muffin","Nutella","Pudding","Sundae","Twinkie","Chicklet","Godiva","Hershey","Jelly Bean","KitKat","Licorice","Lollipop/Lolli","Reese’s","Sugar Plum","Skittles","Snickers","Toffee","Tootsie","Truffles","Alfredo","BBQ","Buffalo","Curry","Drumstick","Dumpling","General Tsao","Kabob","Noodle(s)","KFC","Kiev","Nugget","Pattie","Pollo","Rotisserie","Sesame","Stir Fry","Teriyaki","Almond","Beans","Cap’n Crunch","Cherrio","Chex","Chickpea","Cocoa Puff","Cornflake","Crackers","Honeycomb","Kix","Lucky Charm","Marmalade","Mayo","Oats","Peanut","Peanut Butter","Special K","Basil","Cilantro","Cinnamon","Clove","Curry","Dill","Ginger","Hazelnut","Oregano","Mint","Nutmeg","Paprika","Parsley","Pepper","Rosemary","Salt","Thyme","Saffron","Brandy","Champagne","Chardonnay","Coffee","Cognac","Egg Nog","Lemon Drop","Lemonade","Malt","Margarita","Merlot","Milkshake","Mocha","Mojito","Oolong","Sangria","Tequila","Whiskey"],
    earth_nature: ["Ash","Aspen","Birch","Buckeye","Cedar","Clover","Cypress","Fern","Holly","Juniper","Maple","Rue","Sage","Spruce","Willow","Branch","Clay","Cliff","Forest","Marble","Meadow","Mountain","Pebbles","Rocky","Sandy","Sky","Stony","Twigs","Bo","Brooks","Coral","Dew","Harbor","Laguna","Marlin","Misty","Oceana","Rio","Ripple","River","Stream","Bird","Birdie","Blackbird","Bunny","Chickadee","Dove","Eagle","Finch","Hawk","Owl","Penguin","Raven","Robin","Sparrow","Swan","Autumn","Dawn","eclipse","Eve","Midnight","Moonlight","Moonshine","Solstice","Spring","Summer","Sunrise","Twilight","Winter","Breezy","Cloud","Frost(y)","Ice","Lightning","Rain","Rainbow","Snowflake","Snowy","Storm(y)","Sunny","Sunshine","Windy","Blossom","Bluebell","Daffodil","Dahlia","Daisy","Dandelion","Daphne","Iris","Lavender","Lily","Magnolia","Pansy","Petunia","Rose","Sweetpea","Amber","Amethyst","Beryl","Crystal","Diamond","Emerald","Garnet","Ivory","Opal","Jade","Onyx","Pearl","Ruby","Sapphire","Topaz"],
    old_lady: ["Agatha","Agnes","Alma","Beatrice","Beatrix","Bertha","Bessie","Blanche","Claudine","Constance","Delilah","Doris","Dorothy","Edith","Edna","Edwina","Estelle","Ethel","Flo","Florence","Genevieve","Georgia","Gertrude","Gladys","Gloria","Gwendoline","Ingrid","Irene","Iris","Jude","Mabel","Marge","Martha","Mary-Lou","Maureen","Mavis","Mildred","Muriel","Myrtle","Nancy","Norma","Otis","Prudence","Ramona","Rita","Ruth","Sofia","Trudy","Uma","Ursula","Winifred","Winnie"],
    pairs: ["Amelia & Abigail Gabble","Beavis & Butthead","Biscuits & Gravy","Bo & Peep","Bonnie & Clyde","Bumble & Bee","Buttons & Bows","Cagney & Lacey","Cherry & Blossom","Cinnamon & Spice","Cocoa & Mocha","Cookies & Cream","Doodle & Doo","Elvis & Priscilla","Flopsy & Mopsy","Giggles & Wiggles","Harry & Sally","Hip & Hop","Holmes & Watson","Hugs & Kisses","Laverne & Shirley","Lucy & Ethel","Mac & Cheese","Mary & Rhoda","Mary Kate & Ashley","Peanut Butter & Jelly","Peek & Boo","Pip & Squeak","Polly & Esther","Salt & Pepper","Salt & Vinegar","Sonny & Cher","Sugar & Spice","Thelma & Louise","Tweedle Dee & Tweedle Dum","Wilma & Betty","Yin & Yang","Zing & Zang"],
    trios: ["Bacon, Lettuce, & Tomato","Barbie, Skipper, & Kelly","Beyoncé, Kelly, & Michelle","Bidditi, Bodditi, & Boo","Blanche, Sophia, Dorothy, & Rose","Blossom, Bubbles, & Buttercup","Charlie, Sally, Lucy, Linus, & Snoopy","Charlotte, Carrie, Miranda, & Samantha","Elmo, Big Bird, & Oscar","Flora, Fauna, & Merryweather","Ginger, Maryann, & Mrs. Howell","Gomez, Morticia, Wednesday, & Pugsley","Green, Eggs, & Ham","Jasmine, Aladdin, & Abu","Kelly, Jessie, & Lisa","Mario, Luigi, & Princess Peach","Marsha, Jan, & Cindy","Pooh, Tigger, Piglet, & Eeyore","Regina, Karen, Gretchen, Cady, Janis, & Aaron","Rock, Paper, Scissors","Sandy, Betty, Frenchy, & Danny","Scary, Sporty, Baby, Ginger, & Posh","Snap, Crackle, & Pop","Wendy, Peter Pan, & Tinkerbell"],
    rooster: ["Albert","Atticus","Baron","Bernard","Billie","Bo","Bob","Bruce","Chester","Chuck","Duke","Dusty","Earl","Fletcher","Floyd","George","Gus","Guy","Hank","Howard","Jimmy","Kevin","Leonard","Louis","Maximus","Oliver","Rhett","Rusty","Scout","Teddy","Tyson","Vinny","Watson","Willie","Willy","Winston","Angry Bird","Big Daddy","Big Red","Blackbeard","Bobzilla","Bojangles","Brewster the Rooster","Buckbeak","Cadillac","Cockadoodledoo","Cooper","Dr. Pecker","Everest","Guardian","Jagger","Jupiter","Mohawk","Mr. Feathers","Mr. Woo","Muggle","Napoleon","Ninja","Oz","Rex","Roadkill","Rock the Cock","Rockstar","Roux","Saturn","Sir Clucks-a-lot","Sir Crows A lot","Starbuck","Tank","Thunderbird","Venus","Wooster","Batman","Beaker","Big Bird","Charlie Brown","Colonel Sanders","Cornelius","Doc","Dumbledore","Elmer","Elvis","Fabio","Foghorn Leghorn","Galileo","Gandalf the Gray","Geronimo","Godzilla","Hagrid","Hercules","HippoGriff","Jaws","John HanCock","Kellogg","Little Richard","Lurch","Oscar the Grouch","Pluto","Popeye","Rocky Road","Rooster Cogburn","Severus Snape","Shrek","Spartacus","Superman","Weird Al","Woodstock","Zazu"]
  };

  var PAGE_SIZE = 20;
  var STORAGE_KEY = 'mf4_faves';
  var allNamesCache = null;
  var categoryOrders = Object.create(null);
  var categoryPages = Object.create(null);
  var letterPages = Object.create(null);
  var lastQueryKey = null;

  function getFavorites() {
    try {
      var saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(saved) ? saved : [];
    } catch (error) {
      return [];
    }
  }

  function saveFavorites(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (error) {
      // Favorites still work for the current page even if storage is unavailable.
    }
  }

  function getAllNames() {
    if (allNamesCache) return allNamesCache;

    var combined = [];
    var seen = Object.create(null);

    Object.keys(NAMES).forEach(function (key) {
      NAMES[key].forEach(function (name) {
        var uniqueKey = name.toLowerCase();
        if (seen[uniqueKey]) return;
        seen[uniqueKey] = true;
        combined.push(name);
      });
    });

    allNamesCache = combined;
    return allNamesCache;
  }

  function activeCategory() {
    var selected = elements.pills.querySelector('.pill[aria-pressed="true"]');
    return selected ? selected.getAttribute('data-val') : 'any';
  }

  function shuffledIndexes(length) {
    var indexes = new Array(length);
    var index;

    for (index = 0; index < length; index += 1) {
      indexes[index] = index;
    }

    for (index = length - 1; index > 0; index -= 1) {
      var randomIndex = Math.floor(Math.random() * (index + 1));
      var temporary = indexes[index];
      indexes[index] = indexes[randomIndex];
      indexes[randomIndex] = temporary;
    }

    return indexes;
  }

  function getCategoryPage(category, advance) {
    var key = category || 'any';
    var list = key === 'any' ? getAllNames() : (NAMES[key] || []);

    if (!list.length) return [];

    if (!categoryOrders[key] || categoryOrders[key].length !== list.length) {
      categoryOrders[key] = shuffledIndexes(list.length);
      categoryPages[key] = 0;
    }

    var totalPages = Math.max(1, Math.ceil(list.length / PAGE_SIZE));
    var currentPage = categoryPages[key] || 0;
    var page = advance ? currentPage + 1 : currentPage;

    if (page >= totalPages) {
      page = 0;
      categoryOrders[key] = shuffledIndexes(list.length);
    }

    categoryPages[key] = page;

    return categoryOrders[key]
      .slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE)
      .map(function (nameIndex) {
        return list[nameIndex];
      });
  }

  function getLetterMatches(category, letter) {
    var source = category && category !== 'any'
      ? (NAMES[category] || [])
      : getAllNames();

    var normalizedLetter = letter.toLowerCase();
    var seen = Object.create(null);
    var matches = [];

    source.forEach(function (name) {
      if (name.charAt(0).toLowerCase() !== normalizedLetter) return;

      var uniqueKey = name.toLowerCase();
      if (seen[uniqueKey]) return;

      seen[uniqueKey] = true;
      matches.push(name);
    });

    matches.sort(function (a, b) {
      return a.localeCompare(b, undefined, { sensitivity: 'base' });
    });

    return matches;
  }

  function getLetterPage(category, letter, advance) {
    var normalizedLetter = letter.toLowerCase();
    var key = (category || 'any') + '|' + normalizedLetter;
    var list = getLetterMatches(category, normalizedLetter);

    if (!list.length) return [];

    var totalPages = Math.max(1, Math.ceil(list.length / PAGE_SIZE));
    var currentPage = letterPages[key] || 0;
    var page = advance ? (currentPage + 1) % totalPages : currentPage;
    var start = page * PAGE_SIZE;

    letterPages[key] = page;

    return list.slice(start, start + PAGE_SIZE);
  }

  function createNameCard(name) {
    var card = document.createElement('div');
    var title = document.createElement('strong');
    var favoriteButton = document.createElement('button');

    card.className = 'name';
    title.textContent = name;

    favoriteButton.type = 'button';
    favoriteButton.className = 'btn-outline fav';
    favoriteButton.setAttribute('data-fav', name);
    favoriteButton.setAttribute('aria-label', 'Favorite ' + name);
    favoriteButton.textContent = '⭐';

    card.appendChild(title);
    card.appendChild(favoriteButton);

    return card;
  }

  function renderNames(container, names) {
    var fragment = document.createDocumentFragment();

    container.textContent = '';

    names.forEach(function (name) {
      fragment.appendChild(createNameCard(name));
    });

    container.appendChild(fragment);
  }

  function updateFavoriteStates() {
    var favorites = getFavorites();
    var lookup = Object.create(null);

    favorites.forEach(function (name) {
      lookup[name] = true;
    });

    $all('[data-fav]').forEach(function (button) {
      var active = Boolean(lookup[button.getAttribute('data-fav')]);
      button.classList.toggle('active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function renderFavorites() {
    renderNames(elements.favorites, getFavorites());
    updateFavoriteStates();
  }

  function renderResults(names) {
    renderNames(elements.results, names);
    elements.empty.style.display = names.length ? 'none' : 'block';
    updateFavoriteStates();
  }

  function resetCategory(category) {
    categoryPages[category] = 0;
    categoryOrders[category] = null;
  }

  function runCurrentQuery(advance) {
    var letter = elements.letter.value.trim().charAt(0);
    var category = activeCategory();
    var normalizedLetter = letter.toLowerCase();
    var queryKey = letter
      ? 'letter:' + category + '|' + normalizedLetter
      : 'category:' + category;

    if (!advance || queryKey !== lastQueryKey) {
      if (letter) {
        letterPages[category + '|' + normalizedLetter] = 0;
      } else {
        resetCategory(category);
      }
    }

    lastQueryKey = queryKey;

    var names = letter
      ? getLetterPage(category, letter, Boolean(advance))
      : getCategoryPage(category, Boolean(advance));

    renderResults(names);
  }

  elements.pills.addEventListener('click', function (event) {
    var pill = event.target.closest('.pill');
    if (!pill || !elements.pills.contains(pill)) return;

    $all('#mf4-quick-vibes .pill').forEach(function (button) {
      button.setAttribute('aria-pressed', 'false');
    });

    pill.setAttribute('aria-pressed', 'true');
    elements.vibe.value = pill.getAttribute('data-val');
    elements.letter.value = '';

    var category = activeCategory();
    resetCategory(category);
    lastQueryKey = 'category:' + category;

    renderResults(getCategoryPage(category, false));
  });

  elements.generate.addEventListener('click', function () {
    runCurrentQuery(false);
  });

  elements.refresh.addEventListener('click', function () {
    runCurrentQuery(true);
  });

  if (elements.moreNames) {
    elements.moreNames.addEventListener('click', function () {
      runCurrentQuery(true);
    });
  }

  elements.letter.addEventListener('input', function () {
    this.value = this.value.replace(/[^a-z]/gi, '').slice(0, 1);

    elements.results.textContent = '';
    elements.empty.style.display = 'block';
    lastQueryKey = null;
  });

  elements.letter.addEventListener('keydown', function (event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      elements.generate.click();
    }
  });

  scope.addEventListener('click', function (event) {
    var favoriteButton = event.target.closest('[data-fav]');
    if (!favoriteButton || !scope.contains(favoriteButton)) return;

    var name = favoriteButton.getAttribute('data-fav');
    var favorites = getFavorites();
    var existingIndex = favorites.indexOf(name);

    if (existingIndex === -1) {
      favorites.push(name);
    } else {
      favorites.splice(existingIndex, 1);
    }

    saveFavorites(favorites);
    renderFavorites();
  });

  // Do not generate default results on page load.
  elements.results.textContent = '';
  elements.empty.style.display = 'block';
  renderFavorites();

  return true;
  }

  function bootGenerator() {
    if (initializeGenerator()) return;

    var observer = new MutationObserver(function () {
      if (initializeGenerator()) {
        observer.disconnect();
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    window.setTimeout(function () {
      observer.disconnect();
    }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootGenerator, { once: true });
  } else {
    bootGenerator();
  }

  window.addEventListener('pageshow', initializeGenerator);
})();
